export interface HipoApiErrorShape {
  type: HipoApiErrorType;
  detail: HipoApiErrorDetailShape;
  fallback_message: string;
}

export interface HipoApiErrorDetailShape {
  [x: string]: undefined | any;
}
export type HipoApiErrorType = ValueOf<typeof HIPO_API_ERROR_TYPES>;

const HIPO_API_ERROR_TYPES = {
  NOT_FOUND: "Http404"
} as const;

const HTTP_STATUS_CODES = {
  NOT_FOUND: 404
} as const;

const GENERIC_ERROR_MESSAGE = "Something went wrong, please try again later.";

export {GENERIC_ERROR_MESSAGE, HIPO_API_ERROR_TYPES, HTTP_STATUS_CODES};
